import { Component, Input, Renderer2, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonModule } from "@angular/common";
import { Table, TableLazyLoadEvent, TableModule } from "primeng/table";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { FreightChargesListDto } from "../../../core/models/freight-quote/freightChargesListDto";
import { LoaderService } from "../../../core/services/loader.service";
import { FreightQuoteService } from "../../../core/services/freight-quote.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import { FreightQuotationFormComponent } from "../freight-quotation-form/freight-quotation-form.component";
import { GenericFilterRequestDto } from "../../../core/models/generic-filter-request.dto";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { FreightListingDto } from "../../../core/models/freight-quote/freightListingPayload.dto";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";

@Component({
  selector: "jni-freight-listing",
  templateUrl: "./freight-listing.component.html",
  styleUrl: "./freight-listing.component.scss",
  providers: [],
  imports: [
    CommonModule,
    TableModule,
    DialogModule,
    ConfirmDialogModule,
    ConfirmDialogComponent,
    ModalStackerComponent,
    NgxExtendedPdfViewerModule,
    FreightQuotationFormComponent,
    SpinnerComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class FreightListingComponent {
  @Input() saleOrderId = "";
  totalAmount = 0;
  quotationDisplayModal = false;
  clearAlertVisible = false;
  quoteId!: number;

  FreightChargesLists: FreightChargesListDto[] = [];
  filterFreightChargesLists: FreightChargesListDto[] = [];
  isFreightFormChanged = false;

  totalFreightCost!: number;
  totalFreightRetail!: number;
  totalFreightSell!: number;
  totalProcessingfees!: number;
  totalBilledCharge!: number;
  totalTaxCredit!: number;
  fileName = "FreightCharges";
  orderTrackingDisplayModal = false;
  trackingNumber = "";
  pdfViewerPage = false;
  base64Pdf = "";
  fileNameToDownload = "";
  lazyLoadEvent!: TableLazyLoadEvent;
  totalRecords = 0;
  addressClearMessage = "All data will be lost do you want to exit?";

  @ViewChild("dt") table!: Table;

  constructor(
    private _loaderService: LoaderService,
    public _activatedRoute: ActivatedRoute,
    private _toastr: JniToastrService,
    private renderer: Renderer2,
    private _freightQuoteService: FreightQuoteService
  ) {}

  clearTable(table: Table) {
    table.clear();
  }

  getFreightQuoteList(event: TableLazyLoadEvent) {
    this.lazyLoadEvent = event;
    const eventFilterArray = Object.keys(event.filters ?? {});
    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      const tableFilter = event?.filters?.[x] as GenericFilterRequestDto;
      const data = {
        columnName: x ?? "",
        matchMode: tableFilter.matchMode ?? "",
        tableName: "",
        value: tableFilter.value ?? "",
      } as GenericFilterRequestDto;
      return data;
    });

    filter.forEach(x => {
      if (x.columnName == "total") {
        x.tableName = "freightestimationsectionpackages";
      } else {
        x.tableName = "freightestimationheaders";
      }
    });

    const payload: FreightListingDto = {
      skip: event?.first ?? 0,
      take: event?.rows ?? 20,
      filters: filter,
    };

    this._loaderService.setLoaderState(true);
    this._freightQuoteService.getFreightQuotesList(payload).subscribe({
      next: res => {
        this.totalRecords = 0;
        this.FreightChargesLists = [];
        if (res.status.toLowerCase() != "success") {
          this._loaderService.setLoaderState(false);
          this._toastr.error(res.message, "Error");
        } else {
          this._loaderService.setLoaderState(false);
          if (res.totalRecords) {
            this.totalRecords = res.totalRecords;
          }
          this.FreightChargesLists = res.data;
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  redirectToQuotation(quoteId: string) {
    if (quoteId) {
      this.quoteId = parseInt(quoteId, 10);
      this.quotationDisplayModal = true;
    } else {
      this.quotationDisplayModal = true;
    }
  }

  onFreightFormChanged(hasChanges: boolean) {
    this.isFreightFormChanged = hasChanges;
  }

  closeModalForQuotation() {
    if (this.isFreightFormChanged) {
      this.clearAlertVisible = true;
    } else {
      this.quoteId = 0;
      this.quotationDisplayModal = false;
      this.getFreightQuoteList(this.lazyLoadEvent);
    }
  }

  confirmCloseModalForQuotation(event: boolean) {
    if (event) {
      this.quoteId = 0;
      this.quotationDisplayModal = false;
    }
    this.clearAlertVisible = false;
  }

  downloadPdf(quoteId: string) {
    this._loaderService.setLoaderState(true);

    const quoteInt = parseInt(quoteId, 10);
    this._freightQuoteService.generateQoutePdfById(quoteInt).subscribe(res => {
      if (res?.status.toLowerCase() === "success" && res?.data) {
        this._loaderService.setLoaderState(false);
        this.base64Pdf = res.data?.pdfBase64;
        this.fileNameToDownload = `QuotationPDF-${quoteInt}`;
        this.pdfViewerPage = true;
      } else {
        this._toastr.error("Error", res?.message || `Error generating the PDF`);
      }
    });
  }

  closeModalPdfViewerPage() {
    this.pdfViewerPage = false;
  }
}
